import styled from "styled-components";
import backgroundHeader from '../../../assets/logo/background-header.png';

export const HeaderStyle = styled.header`
  background-image: url(${backgroundHeader});
  background-position: center;
  background-size: cover;
  display: flex;
  color: #fff;
  img {
    padding: 0.5rem;
    height: 80px;
    width: auto;
    cursor: pointer;
  }
  button {
    height: 100%;
    position: relative;
	border: none;
	background: none;
    
    span {
      position: relative;
    }
  }
`;
